// extracted by mini-css-extract-plugin
export default {"container":"SimplePicker_container__ZzJp+"};